import { Suspense } from 'react';
import { EducationAdsCard } from '@/app_components/common/widgets/EducationAdsCard';
import { WidgetBuilder, type WidgetData } from '@/app_data/widgets/utils';
import { insertAtNodeRule } from '@/app_lib/htmlParser/inserter/rules/helpers';
import type { ParserRule } from '@/app_lib/htmlParser/inserter/rules/types';
import { AnalyticsEvent, ContentPlacement } from '@/app_lib/types/analytics';

interface EmbedEducationWidgetsProps {
  adPosition: number;
  ads: WidgetData;
  embedIndex?: number;
}

export const embedEducationWidgetsRule = ({ adPosition, ads, embedIndex }: EmbedEducationWidgetsProps): ParserRule => ({
  insertComponent: () => (
    <div
      className={AnalyticsEvent.ImpressionElement}
      data-cy={`${ContentPlacement.EducationArticleInstreamAd}_${embedIndex}`}
      key={`edu-card-instream-${embedIndex}`}
    >
      <Suspense fallback={null}>
        <EducationAdsCard
          data={WidgetBuilder(ads)}
          index={embedIndex}
          position='in_stream'
        />
      </Suspense>
    </div>
  ),
  insertPosition: adPosition === -1 ? 'end' : 'after',
  match: ({ node, nodeTracker }) => {
    if (adPosition === -1) {
      return true;
    }
    return insertAtNodeRule({ node, nodeTracker, nodeType: 'p', position: adPosition });
  },
});
